import DebouncedTextField from "@/components/DebouncedTextField";
import { inputLabel } from "@/components/MaskInput";
import SectionAccordion from "./SectionAccordion";
import { useSectionRequirement } from "../section-requirement-context";
import {
  FREE_TEXT_MAX_ROWS,
  FREE_TEXT_PLACEHOLDER,
} from "../readmission-f2f-constant";

export interface FreeTextSectionProps {
  title: string;
  expanded: boolean;
  onToggle: () => void;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
}

const FreeTextSection = ({
  title,
  expanded,
  onToggle,
  value,
  onChange,
  placeholder = FREE_TEXT_PLACEHOLDER,
  rows = 4,
}: FreeTextSectionProps) => {
  const summaryLines = value.trim() ? [value.trim()] : [];
  const { isRequired, missingError } = useSectionRequirement();
  const requiredError = missingError(value);

  return (
    <SectionAccordion
      title={title}
      expanded={expanded}
      onToggle={onToggle}
      summaryLines={summaryLines}
      unmountWhenCollapsed
    >
      {isRequired && inputLabel(title, true)}
      <DebouncedTextField
        size="small"
        fullWidth
        multiline
        minRows={rows}
        maxRows={FREE_TEXT_MAX_ROWS}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        error={!!requiredError}
        helperText={requiredError}
      />
    </SectionAccordion>
  );
};

export default FreeTextSection;
